if (!customElements.get('bundle-product')) {
  class BundleProduct extends HTMLElement {
    selected = false;
    multipleSelection = this.dataset.multipleSelection === 'true';

    constructor() {
      super();
    }

    connectedCallback() {
      this.attachEvents();
    }

    /**
     * Attaches the necessary event listeners.
     */
    attachEvents() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    /**
     * Dispatches the variantAdded event.
     */
    onClick() {
      this.classList.toggle('is-selected');
      this.selected = !this.selected;

      if (this.multipleSelection) return;

      const selectedProducts = this.parentElement.querySelectorAll('bundle-product.is-selected');
      for (const product of selectedProducts) {
        if (product !== this) {
          product.classList.remove('is-selected');
          product.selected = false;
        }
      }
    }
  }
  customElements.define('bundle-product', BundleProduct);
}